__webpack_require__.p = "https://legacy.chronos.it-pal.net/";